import React from 'react';
import styled from 'styled-components';
import { Popup } from 'semantic-ui-react';
import DataDictionaryInfo from '../../../../DataDictionaryInfo';
import { DictionaryType } from '../../../../../pages/Dictionary/utils/utils';
import { IFieldFieldsFragment } from '../../../../../utils/apollo/graphqlSchema';
import { theme } from '../../../../../styles/theme';
import { floatingComponentStyles } from '../../../../../styles/shareableStyles';
import { useFloatingLayerContext } from '../../../../FloatingManager';

interface IProps {
  field: IFieldFieldsFragment;
}

const StyledPopup = styled(({ ...props }) => <Popup {...props} />)`
  &&& {
    width: 100%;
    padding: 0;
    border: 0;
    ${floatingComponentStyles};
  }
`;

const FieldName = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  color: ${theme.colors.mainBlue};
`;

const BasicFilterPredicateField = ({ field }: IProps) => {
  const zIndex = useFloatingLayerContext();

  return (
    <StyledPopup
      trigger={<FieldName>{field.name}</FieldName>}
      content={<DataDictionaryInfo type={DictionaryType.Field} item={field} />}
      position="bottom left"
      offset={[0, -3]}
      hoverable
      // hides pointing arrow
      basic={true}
      style={{
        zIndex,
      }}
    />
  );
};

export default BasicFilterPredicateField;
